import type { LegalSection } from './legal-section';

export const PRIVACY_MISC: readonly LegalSection[] = [
  {
    title: '7. Plazos de conservación',
    body: `Cuenta activa: vigencia de la relación.

Registros financieros y wallet: 10 años (Prevención de Blanqueo de Capitales).

Datos identificativos básicos: 6 años (Código de Comercio).

Huella digital: 12 meses.`,
  },
  {
    title: '8. Derechos del interesado',
    body: `Usted dispone de los derechos de Acceso, Rectificación, Supresión, Limitación, Portabilidad y Oposición. Puede ejercerlos enviando un email a support@debook.app adjuntando prueba de identidad.`,
  },
  {
    title: '10. Decisiones automatizadas',
    body: `La plataforma adopta decisiones automatizadas para asignar rangos de calidad (rank), cálculo de tramos de precios y activación de estados de ban/pre-ban basados en la productividad y veracidad de datos. Tiene derecho a intervención humana solicitándolo en el plazo de 14 días.`,
  },
];
